import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ActionConfirmComponent } from '../../../../components/ui/actionconfirm/actionconfirm.component';
import { ActionConfirmModel } from '../../../../models/action-confirm.model';
import { MenuItemsService } from '../../../../services/api-store/menu-items/menu-items.service';
import { MenuService } from '../../../../services/api-store/menu/menu.service';
import { HeaderEntityItemsCreateComponent } from '../header-entity-items-create/header-entity-items-create.component';
import { HeaderEntityItemsEditComponent } from '../header-entity-items-edit/header-entity-items-edit.component';
import { SpinnerService } from '../../../../services/spinner/spinner.service';
import { DIALOG_LARGE_CONFIG, DIALOG_MEDIUM_CONFIG } from '../../../../utils/config/modal-settings';
import { TRUE } from '../../../../utils/config/const';

@Component({
  selector: 'app-header-entity-items',
  templateUrl: './header-entity-items.component.html',
  styleUrls: ['./header-entity-items.component.scss']
})
export class HeaderEntityItemsComponent {

  @Input() inputIdMenu: any;
  @Input() inputMenuItems: any = [];

  constructor(
    private router: Router,
    private menuService: MenuService,
    private menuItemsService: MenuItemsService,
    private domSanitizer: DomSanitizer,
    private spinner: SpinnerService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) { }

  clickButtonCreateItem() {
    //Apre modale di create
    let lastPositionIndex = this.inputMenuItems.length - 1;
    let valLastIndex = null;
    if (this.inputMenuItems.length > 0) {
      lastPositionIndex = this.inputMenuItems.length - 1;
      valLastIndex = this.inputMenuItems[lastPositionIndex].index;
    }
    const modalRef = this.modalService.open(HeaderEntityItemsCreateComponent, DIALOG_LARGE_CONFIG);
    modalRef.componentInstance.menuId = this.inputIdMenu;
    modalRef.componentInstance.lastIndex = valLastIndex;
    modalRef.result.then(result => {
      if (result) {
        if (result != "CLOSE") {
          this.refreshInputMenuItems();
        }
      }
    }, (error) => {
      console.log(error);
    });
  }

  refreshInputMenuItems() {
    this.menuService.getEntity(this.inputIdMenu).subscribe(
      (response) => {
        if (response) {
          //Salvato
          this.inputMenuItems = response.menuItems;
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore', 'Refresh sezione', {
          timeOut: 5000
        });
      }
    );
  }


  /*  Start Action Rows */

  clickButtonPublishedItem(obj, value) {
    this.menuItemsService.publish(obj.id, value).subscribe(
      (response) => {
        if (response) {
          this.toastr.success('Sezione modificata con successo', 'Modifica sezione');
          obj.published = value;
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore', 'Pubblica/Depubblica sezione', {
          timeOut: 5000
        });
      }
    );
  }

  clickButtonUpdateItem(id) {
    //Apre modale di modifica
    const modalRef = this.modalService.open(HeaderEntityItemsEditComponent, DIALOG_LARGE_CONFIG);
    modalRef.componentInstance.id = id;
    modalRef.result.then(result => {
      if (result) {
        if (result != "CLOSE") {
          let id = result.id;
          let position = this.getPositionItemByID(id);
          this.inputMenuItems[position] = result;
        }
        
      }
    }, (error) => {
      console.log(error);
    });
  }

  clickButtonDeleteItem(id) {
    const modalRef = this.modalService.open(ActionConfirmComponent, DIALOG_MEDIUM_CONFIG);
    modalRef.componentInstance.actionTemplate = new ActionConfirmModel();
    modalRef.componentInstance.actionTemplate.title = "Delete";
    modalRef.componentInstance.actionTemplate.body = "Sei sicuro di voler cancellare questa sezione?";
    modalRef.componentInstance.actionTemplate.textButtonConfirm = "Conferma";
    modalRef.componentInstance.actionTemplate.textButtonCancel = "Annulla";
    modalRef.result.then(result => {
      if (result) {
        if (result.confirm === TRUE) {
          this.deleteItems(id);
        }
      }
    }, (error) => {
      console.log(error);
    });
  }

  clickButtonMoveUpItem(id) {
    this.moveUpItem(id);
  }

  clickButtonMoveDownItem(id) {
    this.moveDownItem(id);
  }

  /*  End Action Rows */

  deleteItems(id) {
    this.menuItemsService.delete(id).subscribe(
      (response) => {
        this.toastr.success('Sezione cancellata con successo', 'Cancella sezione');
        for (let i = 0; i < this.inputMenuItems.length; i++) {
          if (this.inputMenuItems[i].id == id) {
            this.inputMenuItems.splice(i, 1);
          }
        }
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore', 'Pubblica/Depubblica sezione', {
          timeOut: 5000
        });
      }
    );
  }

  updateItem(id, obj) {
    this.menuItemsService.update(id, obj).subscribe(
      (response) => {
        this.toastr.success('Sezione modificata con successo', 'Modifica sezione');
        this.refreshInputMenuItems();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore', 'Modifica sezione', {
          timeOut: 5000
        });
      }
    );
  }

  moveUpItem(id) {
    this.moveItem(id, 'UP');
  }

  moveDownItem(id) {
    this.moveItem(id, 'DOWN');
  }

  moveItem(id, direction) {
    let valDirection = 0;
    let nextPosition = -1;
    if (direction == 'UP') { valDirection = -1; }
    else if (direction == 'DOWN') { valDirection = 1; }
    let position = this.getPositionItemByID(id);
    nextPosition = position + valDirection;
    console.log(nextPosition);
    /*Aggiorno il campo index*/
    if (position >= 0 && position < this.inputMenuItems.length) {
      let newIndex = this.inputMenuItems[position].index + valDirection;
      if (newIndex >= 0) {
        this.inputMenuItems[position].index = newIndex;
        this.updateItem(id, this.inputMenuItems[position]);
      }
    }
  }

  getPositionItemByID(id) {
    let position = this.inputMenuItems.length * (-1);
    let isChange = false;
    let dim = this.inputMenuItems.length;
    for (let i = 0; i < dim && !isChange; i++) {
      if (this.inputMenuItems[i].id == id && !isChange) {
        position = i;
      }
    }
    return position;
  }

  changePositionItem(a, b) {
    let isChange = false;
    let maxPos = this.inputMenuItems.length - 1;
    if (a >= 0 && a <= maxPos && b >= 0 && b <= maxPos) {
      let app = this.inputMenuItems[b];
      this.inputMenuItems[b] = this.inputMenuItems[a];
      this.inputMenuItems[a] = app;
      isChange = true;
    }
    return isChange;
  }


  /**
   * Lista draggable
   */

  numeroPagina: number = 0;
  dimPagina: number = 20;

  private draggedIndex: number;
  public draggedOverIndex: number;
  public rowClickActive: boolean = false;
  onDragStart(index): void {
    this.draggedIndex = index;
  }

  onDrop($event, index): void {
    $event.preventDefault();
    const item = this.inputMenuItems[this.draggedIndex];
    this.inputMenuItems.splice(this.draggedIndex, 1);
    this.inputMenuItems.splice(index, 0, item);
    if (this.draggedIndex != index) {
      this.saveRange(this.inputMenuItems,this.draggedIndex,index);
    }
    this.draggedIndex = -1;
    this.draggedOverIndex = -1;
    this.rowClickActive = false;
  }

  allowDrop($event, index): void {
    this.draggedOverIndex = index;
    $event.preventDefault();
  }

  rowClickMouseDown($event) {
    this.rowClickActive = true;
  }

  rowClickMouseUp($event) {
    this.rowClickActive = false;
  }

  saveRange(itemList,start,end){
    console.log(start+" : "+end);
    let startLoop = 0;
    let endLoop =0;
    if(start > end){
      startLoop = end;
      endLoop = start;
    }else if(start < end){
      startLoop = start;
      endLoop = end;
    }

    for(let i=startLoop; i<= endLoop; i++){
      this.updateIndex(itemList[i],i);
    }
  }

  updateIndex(obj,newIndex){
    obj.index = newIndex+1;
    this.updateItem(obj.id, obj);
  }

}
